var UNIFORM_SITENAME_PREFIX = 'uniform__';
export var ensureUniformSiteName = function ensureUniformSiteName(siteName) {
  // keep not defined values untouched
  if (!siteName) {
    return siteName;
  }
  // defensive code
  if (siteName.startsWith(UNIFORM_SITENAME_PREFIX)) {
    return siteName;
  }
  return UNIFORM_SITENAME_PREFIX + siteName;
};